export default "__VITE_ASSET__CeokVaAj__"